import { Box, Drawer } from '@mantine/core'
import { useDisclosure, useViewportSize } from '@mantine/hooks'
import React from 'react'
import { FiltersButton } from 'components/ComposedFilters/FiltersButton'
import Icon from 'components/Icon/Icon'

export const TypesenseMobileFilterAndSort = ({ children }) => {
  const { height } = useViewportSize()
  const [isOpened, { toggle }] = useDisclosure(false)

  return (
    <Box w="100%">
      <FiltersButton onClick={toggle}>Sort And Filters</FiltersButton>
      <Drawer
        position="bottom"
        size={height - 80}
        opened={isOpened}
        onClose={() => {
          toggle()
        }}
        keepMounted
        closeButtonProps={{
          icon: <Icon.Cross size={40} />,
        }}
      >
        <Box px="1rem" mt="2rem">
          {children}
        </Box>
      </Drawer>
    </Box>
  )
}
